module.exports = __webpack_public_path__ + "static/media/rightchevronblue.17b9edb4.svg";